import React from 'react';
import { Alert, Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

/**
 * مكون تنبيه الأسماء المكررة
 */
const DuplicateWarning = ({ matches, checking, error, onDismiss }) => {
  if (checking) {
    return (
      <div className="mt-2 text-muted small">
        <i className="mdi mdi-loading mdi-spin me-1"></i>
        جارٍ فحص الأسماء المشابهة...
      </div>
    );
  }

  if (error) {
    return (
      <Alert color="danger" className="mt-2 mb-0 py-2 px-3" toggle={onDismiss}>
        <i className="mdi mdi-alert me-1"></i>
        {error}
      </Alert>
    );
  }

  if (!matches || matches.length === 0) return null;

  return (
    <Alert color="warning" className="mt-2 mb-0 py-2 px-3" toggle={onDismiss}>
      <div className="fw-bold mb-1">
        <i className="mdi mdi-alert-circle-outline me-1"></i>
        تم العثور على أسماء مشابهة ({matches.length})
      </div>
      <div style={{ maxHeight: '150px', overflowY: 'auto' }}>
        {matches.map((m, idx) => (
          <div key={idx} className="d-flex align-items-center gap-2 py-1 border-bottom" style={{ fontSize: '0.85rem' }}>
            <span>{getMatchIcon(m.match_type)}</span>
            <span className="fw-semibold">{m.name}</span>
            <span className="badge bg-secondary bg-opacity-25 text-dark">
              {getEntityIcon(m.entity_type)} {m.entity_label}
            </span>
            <span className="text-muted small">({getMatchLabel(m.match_type)})</span>
          </div>
        ))}
      </div>
      <div className="text-muted small mt-1">
        ⚠️ هذا تنبيه فقط • يمكنك المتابعة إذا كان الاسم لشخص مختلف
      </div>
    </Alert>
  );
};

/**
 * مكون بوب أب تأكيد الحفظ مع تحذير التكرار
 */
export const DuplicateSaveConfirm = ({ isOpen, matches, onConfirm, onCancel }) => {
  if (!isOpen || !matches || matches.length === 0) return null;

  return (
    <Modal isOpen={isOpen} toggle={onCancel} centered dir="rtl">
      <ModalHeader toggle={onCancel} className="bg-warning bg-opacity-10">
        <i className="mdi mdi-alert-circle-outline me-2 text-warning"></i>
        تحذير - أسماء مشابهة موجودة
      </ModalHeader>
      <ModalBody>
        <p className="fw-bold mb-3">تم العثور على {matches.length} اسم مشابه في قاعدة البيانات:</p>
        <div style={{ maxHeight: '250px', overflowY: 'auto' }} className="border rounded p-2">
          {matches.map((m, idx) => (
            <div key={idx} className="d-flex align-items-center gap-2 py-2 border-bottom" style={{ fontSize: '0.9rem' }}>
              <span>{getMatchIcon(m.match_type)}</span>
              <span className="fw-semibold">{m.name}</span>
              <span className="badge bg-secondary bg-opacity-25 text-dark">
                {getEntityIcon(m.entity_type)} {m.entity_label}
              </span>
              <span className="text-muted small">({getMatchLabel(m.match_type)})</span>
            </div>
          ))}
        </div>
        <div className="mt-3 p-2 bg-light rounded">
          <p className="mb-0 text-muted">
            <i className="mdi mdi-information-outline me-1"></i>
            هل أنت متأكد أنك تريد الحفظ؟ قد يكون هذا السجل مكرراً.
          </p>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onCancel}>
          <i className="mdi mdi-arrow-right me-1"></i> رجوع وتعديل
        </Button>
        <Button color="warning" onClick={onConfirm}>
          <i className="mdi mdi-check me-1"></i> حفظ على أي حال
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const getMatchIcon = (matchType) => {
  switch (matchType) {
    case 'exact': return '🔴';
    case 'contains': return '🟠';
    case 'partial': return '🟡';
    default: return '⚪';
  }
};

const getMatchLabel = (matchType) => {
  switch (matchType) {
    case 'exact': return 'تطابق تام';
    case 'contains': return 'تطابق قوي';
    case 'partial': return 'تشابه جزئي';
    default: return '';
  }
};

const getEntityIcon = (entityType) => {
  switch (entityType) {
    case 'activist': return '✊';
    case 'journalist': return '📰';
    case 'institution': return '🏛️';
    default: return '';
  }
};

export default DuplicateWarning;
